import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Button from 'components/shared/Button'
import { Container, Row, Col } from 'styled-bootstrap-grid'

import { FormattedMessage } from 'react-intl'
import { isTabletWidth } from 'store/resolutions'
import logoFull from 'assets/images/logos/logo-full.svg'
import { HOME_LINK, LOGIN_LINK, SIGNUP_LINK } from 'constants/links'

interface AccountPageTemplateProps {
    title: JSX.Element
    text: string | JSX.Element
    hasLoginInfoHidden?: boolean
    hasRegistrationButton?: boolean
}

const AccountPageTemplate = ({
    title,
    text,
    hasLoginInfoHidden,
    hasRegistrationButton,
}: AccountPageTemplateProps) => (
    <Container>
        <Row alignItems="center" justifyContent="center">
            <Col col md={6}>
                <Box align="center" mt={[40, 80]}>
                    <a href={HOME_LINK}>
                        <img src={logoFull} alt="Park of Poland logo" />
                    </a>
                    <Text
                        variant="heading2"
                        color="secondary_500"
                        mb={12}
                        mt={64}
                        align="center"
                    >
                        {title}
                    </Text>
                    <Text variant="body" align="center" color="grayscale_700">
                        {text}
                    </Text>
                    {hasLoginInfoHidden ? (
                        <Box
                            isFullWidth={isTabletWidth()}
                            align="center"
                            justify="center"
                            mt={40}
                            gap={16}
                        >
                            {hasRegistrationButton && (
                                <Button variant="primary" href={SIGNUP_LINK}>
                                    <FormattedMessage
                                        id="global.btn.signup"
                                        defaultMessage="Zarejestruj się"
                                    />
                                </Button>
                            )}
                            <Button
                                variant={
                                    hasRegistrationButton
                                        ? 'borderPrimary'
                                        : 'primary'
                                }
                                href={HOME_LINK}
                            >
                                <FormattedMessage
                                    id="global.btn.back_to_homepage"
                                    defaultMessage="Wróć do strony głównej"
                                />
                            </Button>
                        </Box>
                    ) : (
                        <>
                            <Text
                                variant="body"
                                align="center"
                                color="grayscale_700"
                            >
                                <FormattedMessage
                                    id="global.registration_account_log_in"
                                    defaultMessage="Zaloguj się, aby zobaczyć swoje konto i rezerwacje."
                                />
                            </Text>
                            <Box
                                isFullWidth={isTabletWidth()}
                                align="center"
                                justify="center"
                                mt={40}
                            >
                                <Button variant="primary" href={LOGIN_LINK}>
                                    <FormattedMessage
                                        id="global.btn.login"
                                        defaultMessage="Zaloguj się"
                                    />
                                </Button>
                            </Box>
                            <Box
                                isFullWidth={isTabletWidth()}
                                align="center"
                                justify="center"
                                mt={16}
                            >
                                <Button
                                    variant="borderPrimary"
                                    href={HOME_LINK}
                                >
                                    <FormattedMessage
                                        id="global.btn.back_to_homepage"
                                        defaultMessage="Wróć do strony głównej"
                                    />
                                </Button>
                            </Box>
                        </>
                    )}
                </Box>
            </Col>
        </Row>
    </Container>
)

export default AccountPageTemplate
